import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RoleSelectionPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRoleSelection = (role) => {
    navigate('/login', { state: { role } });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">🏠 SaleSign</h1>
          <p className="text-gray-600">{t('roleSelectionPage.subtitle')}</p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => handleRoleSelection('land_reporter')}
            className="w-full p-6 border-2 border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors text-left"
          >
            <div className="flex items-center">
              <div className="text-4xl mr-4">🏗️</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('auth.landReporter')}</h3>
                <p className="text-gray-600 text-sm">
                  {t('roleSelectionPage.reporterDescription')}
                </p>
              </div>
            </div>
          </button>

          <button
            onClick={() => handleRoleSelection('land_seeker')}
            className="w-full p-6 border-2 border-gray-200 rounded-lg hover:border-green-300 hover:bg-green-50 transition-colors text-left"
          >
            <div className="flex items-center">
              <div className="text-4xl mr-4">🔍</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('auth.landSeeker')}</h3>
                <p className="text-gray-600 text-sm">
                  {t('roleSelectionPage.seekerDescription')}
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            ← {t('loginPage.backToHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectionPage;


